import type { SignalSource } from "app/pages/sales-intelligence/domain/signals/types/signal";

import type SignalsService from "../../services/SignalsService";
import type SignalTypeWithIcon from "../SignalTypeWithIcon";

import type SignalTypesListViewModel from "./SignalTypesListViewModel";

type FactoryDeps = {
    signalsService: SignalsService;
    signalSource: SignalSource;
};

export default function createSignalTypesListViewModel(deps: FactoryDeps): Readonly<SignalTypesListViewModel> {
    const { signalsService, signalSource } = deps;

    return {
        get initiallySelectedType() {
            return signalsService.managementSignalTypes[0];
        },
        get signalSource(): SignalSource {
            return signalSource;
        },
        get signalTypes(): readonly SignalTypeWithIcon[] {
            return signalsService.managementSignalTypes.map<SignalTypeWithIcon>((type) => ({
                type,
                icon: signalsService.getIconForSignalType(type),
            }));
        },
    };
}
